import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { FunctionalityStateModel } from './functionality.model';
import { FunctionalityState } from './functionality.state';
import { UserState } from './user.state';

@Injectable()
export class FunctionalityService {
  constructor(private store: Store) {}

  get needsToChooseAccountType(): boolean {
    return this.store.selectSnapshot(UserState.user).needsToChooseAccountType;
  }

  get functionality(): FunctionalityStateModel {
    return this.store.selectSnapshot(FunctionalityState.functionality);
  }
}
